<template>
  <div class="search-results-event">
    <div v-if="results && results.length" class="result-table">
      <div class="header">
        <div class="header-item title">
          {{ $t('CONCERT.PERFORMANCE_TITLE') }}
        </div>
        <div class="header-item time">
          {{ $t('CONCERT.PERFORMANCE_TIME') }}
        </div>
        <div class="header-item venue">
          {{ $t('CONCERT.PERFORMANCE_VENUE') }}
        </div>
      </div>
      <div class="body">
        <div v-for="(event, index) in results" :key="event.id">
          <template v-if="$production.toUpperCase() === 'CONCERT'">
            <div :class="{odd: (index % 2) === 1}" class="row">
              <RouterLink :to="{name: 'eventById', params: {loale: $i18n.localePath(), id: event.id}}" @click="linkOnClick(event)">
                <div class="row-item title" v-html="event.name" />
                <div class="row-item time">
                  {{ transferEventDateText(event.datetime) }}
                </div>
                <div class="row-item venue" v-html="transferEventVenueText(event.venue)" />
              </RouterLink>
            </div>
            <div v-if="(index + 1) % 10 === 0 || (index + 1) === results.length" class="row-pgnnp">
              <Paganiniplus />
            </div>
          </template>
          <template v-else>
            <div :class="{odd: (index % 2) === 1}" class="row">
              <a :href="eventResultURL(event)" target="_blank" rel="noopener noreferrer" @click="linkOnClick(event)">
                <div class="row-item title" v-html="event.name" />
                <div class="row-item time">
                  {{ transferEventDateText(event.datetime) }}
                </div>
                <div class="row-item venue" v-html="transferEventVenueText(event.venue)" />
              </a>
            </div>
            <div v-if="(index + 1) % 10 === 0 || (index + 1) === results.length " class="row-pgnnp">
              <Paganiniplus />
            </div>
          </template>
        </div>
      </div>
    </div>
    <SearchNoResultsText :results="results" />
  </div>
</template>

<script>
import Paganiniplus from '@/components/tsp/Paganiniplus'
// import LoggerService from '@/assets/services/LoggerService'
import { transferEventDateText, transferEventVenueText } from '@/assets/helpers/EventHelper'
import SearchNoResultsText from '@/components/search/SearchNoResultsText'

export default {
  name: 'SearchResultsEvent',
  components: {
    Paganiniplus,
    SearchNoResultsText
  },
  directives: {},
  props: {},
  data() {
    return {}
  },
  computed: {
    results() {
      const matchedObj = this.$store.getters.getSearchResults.find(searchObj => searchObj['event'])
      return matchedObj && matchedObj.event ? matchedObj.event : []
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    transferEventDateText,
    transferEventVenueText,
    eventResultURL(result) {
      return (this.$production.toUpperCase() === 'CONCERT')
        ? `/${this.$i18n.localePath()}/events/${result.id}`
        : `https://${process.env.VUE_APP_MUZIK_CONCERT}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/events/${result.id}`
    },
    linkOnClick(result) {
      // const url = `https://${process.env.VUE_APP_MUZIK_CONCERT}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/events/${result.id}`
      // this.logRecord(result, url)
    },
    logRecord(result, url) {
      // const params = {
      //   userId: this.$store.getters.getProfile.id || '',
      //   peopleCookieId: window.localStorage.getItem('fingerprint') || '',
      //   refer: document.referrer || this.$route.query.refer || '',
      //   keyword: this.keyword,
      //   clickUrl: url,
      //   agent: window.navigator.userAgent
      // }
      // LoggerService.logUserSearchAction(params)
      // // gtag event
      // const searchItemData = `[event] ${result.name} ${result.id}`
      // this.$store.dispatch('GTAG_EVENT', {
      //   action: 'view_search_results',
      //   data: {'search_term': `vent ${result.id}`}
      // })
    }
  }
}
</script>
<style lang="scss" scoped>

@import '@/assets/scss/variables.scss';
// @import '@/assets/scss/component/table.scss';

.result-table {
  .title {
    width: 40%;
  }
  .time {
    width: 20%;
  }
  .venue {
    width: 40%;
  }
  .header {
    width: 100%;
    height: 50px;
    text-decoration: none;
    background-color: $grey-f3;
    &-item {
      display: inline-block;
      height: 48px;
      padding: 12px 0 12px 36px;
      font-size: 16px;
      font-weight: 700;
      line-height: 1.63;
      color: $grey-7d;
    }
  }
  .body {
    .row {
      background-color: #ffffff;
      &.odd {
        background-color: $grey-f3;
      }
      &-item {
        display: inline-block;
        vertical-align: top;
        padding: 12px 0 12px 36px;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.63;
        color: $grey-7d;
        text-decoration: none;
      }
    }
  }
  .row-pgnnp {
    margin: 36px auto;
  }
}

@media only screen and (max-width: 1023.98px) {
  .result-table {
    .header {
      display: none;
    }
    .title,
    .time,
    .venue {
      width: 100%;
    }
    .body {
      .row {
        padding: 8px;
        background-color: $grey-f3;
        &.odd {
          background-color: #ffffff;
        }
        &-item {
          padding: 0;
        }
      }
    }
  }
}
@media only screen and (max-width: 368.98px) {
  .result-table {
    .row-pgnnp {
      margin: 24px -24px;
    }
  }
}
</style>
